@if (hasNotes) {
	<div (click)="onEdit($event)" class="note-button edit-note" (pointermove)="pointerMove($event)">
		<mat-icon (click)="onEdit($event)" class="has-notes" svgIcon="acies_quick_reference"></mat-icon>
		<div #popup class="notes-list hover-popup">
			@for (note of notes; track $index) {
				<mat-chip-set>
					<mat-chip>{{ note.note }}</mat-chip>
				</mat-chip-set>
			}
		</div>
	</div>
} @else {
	<div (click)="onEdit($event)" class="note-button add-notes">
		<mat-icon svgIcon="acies_note_add"></mat-icon>
	</div>
}
